import React from 'react';
import Modal from '../Modal';
import { Icon } from '../Icon';
import { CustomButton } from '../Button/Button';
import { browserName } from 'react-device-detect';
import styles from './InstallExtensionModal.module.scss';
import { useTranslation } from 'react-i18next';

const InstallExtensionModal = ({ open, onClose, handleShowUploadVideoModal }) => {
  const handleStoreStatus = () => {
    localStorage.setItem('recorderInstalled', true);
    onClose();
  };

  const handleVisitStore = () => {
    window.open(`${process.env.DOMAIN}/eg/download-center`, '_blank');
    onClose();
  };

  const handleUploadVideo = async () => {
    handleShowUploadVideoModal();
    onClose();
  };

  const { t } = useTranslation();

  return (
    <Modal className={styles.installModal} onClose={onClose} open={open}>
      <div className={styles.installModalContent}>
        <div className={styles.installModalText}>{t('dashboard.new_video.install.message', { browser: browserName })}</div>
        <div className={styles.closeBtn} onClick={onClose}>
          <Icon className={styles.icon} src="close" />
        </div>
      </div>
      <div className={styles.btnContainer}>
        <CustomButton label={t('dashboard.new_video.install.installed')} variant="basic" onClick={handleStoreStatus} />
        <CustomButton label={t('dashboard.new_video.install.download_recorder')} variant="primary" onClick={handleVisitStore} />
        {handleShowUploadVideoModal && (
          <CustomButton label={t('dashboard.new_video.upload_video.button')} variant="primary" onClick={handleUploadVideo} />
        )}
      </div>
    </Modal>
  );
};

export default InstallExtensionModal;
